import React from 'react'
import cn from 'classnames'
import { observer } from 'mobx-react'

import Modal from 'components/modal/Modal'
import IconButton from 'components/iconButton/IconButton'

import Cross from 'assets/icons/cross.svg'
import Alert from 'assets/icons/alert.svg'

import styles from './dialog.scss'

interface IProps {
  className?: string
  error?: boolean
  title?: string
  primaryButton?: React.ReactChild
  secondaryButton?: React.ReactChild
  children: React.ReactChild
  onClose?: () => void
}

class Dialog extends React.Component<IProps> {
  componentDidMount() {
    document.getElementById('dialog-root')!.style.pointerEvents = 'initial'
  }

  componentWillUnmount() {
    document.getElementById('dialog-root')!.style.pointerEvents = 'none'
  }

  render() {
    const {
      className,
      error,
      title,
      primaryButton,
      secondaryButton,
      children,
      onClose,
    } = this.props
    return (
      <Modal
        data-cy="dialog"
        className={cn(styles.container, className)}
        domElementId="dialog-root"
        darken
        onClickOutside={onClose}
      >
        <>
          {title && (
            <div className={cn(styles.header, { [styles.error]: error })}>
              {error && <Alert />}
              {title}
            </div>
          )}

          {children}

          {(primaryButton || secondaryButton) && (
            <div className={styles.footer}>
              {primaryButton}
              {secondaryButton}
            </div>
          )}

          {onClose && (
            <IconButton className={styles.closeButton} onClick={onClose}>
              <Cross />
            </IconButton>
          )}
        </>
      </Modal>
    )
  }
}

export default observer(Dialog)
